import request from '@/utils/request'

/**
 * 素材分类树
 * @param {*} data
 * @returns
 */
export const getMaterialCategoryTree = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/material/category/tree',
    data: data
  })
}

/**
 * 添加素材分类
 * @returns
 */
export const addMaterialCategory = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/material/category/add',
    data
  })
}

/**
 * 修改素材分类
 * @param {*} data
 * @returns
 */
export const editMaterialCategory = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/material/category/edit',
    data
  })
}

/**
 * 删除素材分类
 * @param {*} id
 */
export const deleteMaterialCategory = (id) => {
  return request({
    method: 'DELETE',
    url: `/sys/v1/material/category/delete/${id}`
  })
}

/**
 * 获取素材分页
 * @param {*} data
 * @returns
 */
export const getMaterialPageList = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/material/pageList',
    data: data
  })
}

/**
 * 添加素材
 * @param {*} data
 * @returns
 */
export const addMaterial = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/material/add',
    data: data
  })
}

/**
 * 获取素材详情
 * @param {*} id
 * @returns
 */
export const getMaterialDetail = (id) => {
  return request({
    url: `/sys/v1/material/detail/${id}`
  })
}

/**
 * 修改素材
 * @param {*} data
 * @returns
 */
export const editMaterial = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/material/edit',
    data: data
  })
}

/**
 * 删除素材
 * @param {*} id
 * @returns
 */
export const deleteMaterial = (id) => {
  return request({
    method: 'DELETE',
    url: `/sys/v1/material/delete/${id}`
  })
}
